import createPersistedState from 'use-persisted-state';
var usePersistedState = createPersistedState('agreesToCookies');
export var useCookieBanner = function useCookieBanner() {
  return usePersistedState();
};